export default __webpack_public_path__ + "static/SVGCard01-698a769c8ebe8068f275e58d17c3e299.svg";